import React from 'react';
import Box from '@mui/material/Box';

export const SvgWrapper: React.FC<{ children: React.ReactNode, size?: number }> = ({ children, size = 24 }) => {
  return (
    <Box style={{ width: size, height: size }} display="flex" alignItems="center" justifyContent="center">
      {children}
    </Box>
  );
};
